import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mFBTC.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mFBTC.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0xC96dE26018A54D51c097160568752c4E3BD6C364",
  testnetAddress: "0x26aD7515F34e9B15ba5827302433d33FC5004D16",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
